export default {
    'playtech.mobile.system.dp.header.daily.title': 'Daily Login Limits',
    'playtech.mobile.system.dp.header.monthly.title': 'Monthly Login Limits',
    'playtech.mobile.system.dp.header.weekly.title': 'Weekly Login Limits',
    'playtech.mobile.system.dp.clock.label.minutes': 'Minutes',
    'playtech.mobile.system.dp.clock.label.hours': 'Hours',
    'playtech.mobile.system.dp.clock.label.days': 'Days',
    'playtech.mobile.system.dp.unlimited.period.set': 'Set Unlimited Period',
    'playtech.mobile.system.dp.unlimited.period.unset': 'Cancel Unlimited Period',
    'playtech.mobile.system.dp.label.unlimited': 'Login Period',
    'playtech.mobile.system.dp.display.dd': 'dd',
    'playtech.mobile.system.dp.display.hh': 'hh',
    'playtech.mobile.system.dp.display.min': 'min',
    'playtech.mobile.system.dp.display.unlimited': 'Unlimited'
};
